import { collection, doc, setDoc } from 'firebase/firestore';
import { db } from '../firebase/firebase';

export const addMessageToFirestore = ({ name, email, message }, documentRef = doc(collection(db, 'messages'))) =>
    setDoc(documentRef, {
        name,
        email,
        message,
        timestamp: new Date(),
    });
